import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { FooterNavigationComponent } from './footer-navigation.component';

@NgModule({
  imports: [NgIf, NgFor, AsyncPipe, NgClass, GenericLinkComponent],
  declarations: [FooterNavigationComponent],
  exports: [FooterNavigationComponent],
})
export class FooterNavigationModule {}
